module.exports = "<symbol id=\"tt-icon-reply\" viewBox=\"0 0 24 24\"><path d=\"M5.43 10.21l4.28-4.56-1.82-2L.5 11.57l7.39 7.9 1.82-2-4.35-4.6a29.76 29.76 0 0 1 10.46 1.71 19.12 19.12 0 0 1 7.68 5.75c-.66-3.33-3.09-5.75-6.13-7.46-2.68-1.51-7.07-2.51-11.94-2.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/Rdhcya1h7lLN3rcsite/assets/svg/pdp-page/reply.svg
// module id = 273
// module chunks = 10